var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"my-link ",class:[("my-link--" + _vm.type), { 'is-underline': _vm.underline }]},[_c('span',{staticClass:"my-link--inner"},[_vm._t("default",function(){return [_vm._v("默认链接")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }